module.exports = __webpack_public_path__ + "static/media/TrainMode.9487f844.jpg";